import { JobCreationResult } from '../models/jobs';
import { API } from '../shared/constants';
import {
    AnalyticsTab,
    EntityAnalyticsTab,
    EntityRolesTab,
    RolesTab
} from '../shared/domain';
import { TabsBaseAdapter } from './tabs-base-adapter';
import { HttpConnectorAdapter } from './http-connector-adapter';

let singletonInstance: TabsAdapter;
export class TabsAdapter implements TabsBaseAdapter {
    static getAdapter(): TabsBaseAdapter {
        if (!singletonInstance) {
            singletonInstance = new TabsAdapter();
        }

        return singletonInstance;
    }

    async getAnalyticsTab(tabId: string): Promise<AnalyticsTab> {
        if (!tabId) {
            return Promise.reject();
        }

        const {
            ANALYTICS: { GET_TAB }
        } = API.URL;

        const response = await HttpConnectorAdapter
            .get(GET_TAB.replace(API.URL.Tokens.ANALYTICS.TAB_ID, tabId));

        const result = AnalyticsTab.create(response.data as EntityAnalyticsTab);
        if (!result){
            return Promise.reject();
        }
        return result;
    }

    async getReportingByRole(): Promise<RolesTab[]> {
        const {
            REPORTING: { REPORTING_BY_ROLE }
        } = API.URL;

        const response = await HttpConnectorAdapter
            .get(REPORTING_BY_ROLE);

        const { 
            status: responseStatus,
            data
        } : {
            status: boolean,
            data: EntityRolesTab[]
        } = response.data;

        if ((!responseStatus) || !data) {
            return Promise.reject();
        }

        const result = data.map((role: EntityRolesTab) => RolesTab.create(role));

        if (!result){
            return Promise.reject();
        }

        return result as RolesTab[];
    }

    async createSecurityReportLink(reportingId: string, parameters: object): Promise<JobCreationResult> {
        const {
            REPORTING: { CREATE_REPORT_LINK }
        } = API.URL;

        const body: {
            reporting_id: string,
            parameters: object
        } = {
            reporting_id: reportingId,
            parameters: parameters
        };

        const response = await HttpConnectorAdapter
            .post(CREATE_REPORT_LINK, body);

        const { 
            status: responseStatus,
            message,
            data
        } : {
            status: boolean,
            message: string,
            data: { job_id: string }
        } = response.data;

        if ((!responseStatus) || !data) {
            return Promise.reject();
        }

        const result: JobCreationResult = {
            status: responseStatus,
            message,
            jobId: data.job_id
        };

        return Promise.resolve(result);
    }
}
